import {HttpRequest} from "../utils/httpRequest";

let SysMenu = {
    /**
     * 获取角色对应菜单
     * @param params
     * @returns {*}
     */
    getMenuRoles(params) {
        return HttpRequest.getRequest({
            url: '/sys/menu/role/all',
            method: 'get',
            data: params
        });
    },
    /**
     * 角色菜单权限
     * @param params
     * @returns {*}
     */
    getMrList(params) {
        return HttpRequest.getRequest({
            url: '/sys/menu/auth',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取生成菜单
     * @param params
     * @returns {*}
     */
    getMenus(params) {
        return HttpRequest.getRequest({
            url: '/sys/menu/all',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取所有菜单
     * @returns {*}
     */
    getMenuList() {
        return HttpRequest.getRequest({
            url: '/sys/menu/list',
            method: 'get'
        });
    },
    /**
     * 获取分页列表
     * @param params
     * @returns {*}
     */
    getMenuByPage(params) {
        return HttpRequest.getRequest({
            url: '/sys/menu/page',
            method: 'get',
            data: params
        });
    },
    /**
     * 删除
     * @param params
     * @returns {*}
     */
    deleteMenu(params) {
        return HttpRequest.getRequest({
            url: '/sys/menu/delete',
            method: 'get',
            data: params
        });
    },
    /**
     * 菜单信息
     * @param id
     * @returns {*}
     */
    getMenuInfo(id) {
        return HttpRequest.getRequest({
            url: '/sys/menu/info/' + id,
            method: 'get'
        })
    },
    /**
     * 新增或编辑系统菜单
     * @param id
     * @param datas
     */
    addOrUpdateSysMenu: function (type, datas) {
        return HttpRequest.getRequest({
            method: 'post',
            url: '/sys/menu/' + type,
            data: datas
        });
    }
};
export {SysMenu}
